export interface AppFeature {
  title: string;
  description: string;
}

// Wording kept from the previous PHP /app page so the page kicks the same
// search terms; only the dead "direct download" copy was dropped.
export const APP_FEATURES: AppFeature[] = [
  {
    title: 'دریافت نوبت',
    description:
      'اولین نوبت خالی برای شماست! مهم نیست چه زمانی و کجا نیازی به پزشک داشته باشید؛ با پذیرش۲۴، همواره اولین زمان خالی پزشکان در اختیار شماست.',
  },
  {
    title: 'انتخاب پزشک',
    description:
      'از میان هزاران پزشک در صدها مرکز درمانی، مناسب‌ترین پزشکان را بر اساس تخصص و فوق‌تخصص مورد نیازتان، هزینه‌های درمان، بیمه‌های طرف قرارداد و نظرات سایر بیماران انتخاب کنید.',
  },
  {
    title: 'ویزیت آنلاین',
    description:
      'حاذق‌ترین پزشکان در هر ساعت از شبانه‌روز آماده ارائه ویزیت آنلاین درمانی به شما هستند؛ مهم نیست برای چه تخصصی و در چه ساعتی به ویزیت آنلاین نیاز داشته باشید.',
  },
  {
    title: 'پیگیری نوبت',
    description:
      'از طریق اپلیکیشن پذیرش۲۴، نوبت‌های خود را به‌راحتی پیگیری، ویرایش یا حتی لغو کنید. با چاپ یا ذخیره قبض نوبت، حتی بدون دسترسی به اینترنت هم از پذیرش خود در مرکز درمانی مطمئن باشید.',
  },
  {
    title: 'امکانات پذیرش۲۴',
    description:
      'از دسترسی رایگان به مجله تخصصی پذیرش۲۴ تا پرونده سلامت الکترونیک، و از ویزیت آنلاین با پزشکان تا یادآور دارویی — همین حالا پذیرش۲۴ را دانلود کنید.',
  },
];

export const APP_ARTICLE_TITLE = 'بررسی مزایای استفاده از اپلیکیشن ویزیت آنلاین و نوبت‌دهی آنلاین';

export const APP_ARTICLE_BODY =
  'استفاده از خدمات غیرحضوری همواره جذابیت‌های خاص خود را به همراه دارد، چراکه در هر مکان و هر زمانی می‌توانید بدون کمترین زحمتی نیازهای خود را برطرف کنید. با اپلیکیشن پذیرش۲۴ می‌توانید ویزیت آنلاین بگیرید و نوبت پزشکی خود را به‌صورت آنلاین رزرو کنید و از شلوغی و حاشیه‌های مراجعه حضوری به مطب‌ها دور بمانید.';
